<div class="section-full small-device p-t30  p-b80  bg-white">

  <div class="container">
  
      <!-- IMAGE CAROUSEL START -->
      <div class="section-content clearfix">
        <div class="col-md-12">
            <div class="row  no-col-gap bg-primary">
            <div class="col-md-3 col-sm-6 col-xs-6 col-xs-100pc bg-white">
                <div class="wt-icon-box-wraper center p-lr30  p-b50 p-t50 bdr-1 bdr-solid bdr-gray-light hover-border-outer hover-border">
                      <div class="icon-lg text-primary m-b15">
                          <span class="icon-cell text-primary"><i class="flaticon-decorating"></i></span>
                      </div>
                      <div class="icon-content text-black">
                          <h4 class="wt-tilte text-uppercase font-weight-600 m-b20">Interior</h4>
                          <p>There are many variations of pass ages of Ipsum</p>
                      </div>
                  </div>
              </div>                          
            <div class="col-md-3 col-sm-6 col-xs-6 col-xs-100pc bg-white">
                <div class="wt-icon-box-wraper center p-lr30  p-b50  p-t50 bdr-1 bdr-solid bdr-gray-light hover-border-outer hover-border">
                      <div class="icon-lg text-primary m-b15">
                          <span class="icon-cell text-primary"><i class="flaticon-skyline"></i></span>
                      </div>
                      <div class="icon-content text-black">
                          <h4 class="wt-tilte text-uppercase font-weight-600 m-b20">Architecture</h4>
                          <p>There are many variations of pass ages of Ipsum.</p>
                      </div>
                  </div>
              </div>
            <div class="col-md-3 col-sm-6 col-xs-6 col-xs-100pc bg-white">
                <div class="wt-icon-box-wraper center p-lr30  p-b50  p-t50 bdr-1 bdr-solid bdr-gray-light hover-border-outer hover-border">
                      <div class="icon-lg text-primary m-b15">
                          <span class="icon-cell text-primary"><i class="flaticon-sketch "></i></span>
                      </div>
                      <div class="icon-content text-black">
                          <h4 class="wt-tilte text-uppercase font-weight-600 m-b20">Planing</h4>
                          <p>There are many variations of pass ages of Ipsum.</p>
                      </div>
                  </div>
              </div>
            <div class="col-md-3 col-sm-6 col-xs-6 col-xs-100pc bg-primary">
                <div class="wt-icon-box-wraper center p-lr30  p-b40 p-t40">
                      <div class="icon-lg m-b15">
                          <span class="icon-cell  text-white"><i class="flaticon-architect-with-helmet"></i></span>
                      </div>
                      <div class="icon-content">
                          <h4 class="wt-tilte text-uppercase font-weight-600 m-b20 text-white">Make pro plan for your projects</h4>
                          <a routerLink="/contact-1" class="site-button-secondry site-btn-effect"><span>Get a quote</span></a>
                      </div>
                  </div>
              </div>
                                                                
          </div>
          </div>
      </div>
  </div>
  
</div>